import React from 'react';
import { Helmet } from 'react-helmet';
interface HeadProps {
  title?: string;
  description?: string;
  canonical?: string;
}
const Head: React.FC<HeadProps> = ({
  // IMPORTANTE: Este título padrão nunca deve ser alterado no build/deploy
  // Ele é o título SEO principal da aplicação e é crítico para indexação
  title = 'Semantic Branding — Otimize sua marca para LLMs | Conversion',
  description = 'Branding semântico é o conjunto de estratégias que conecta marcas a atributos específicos, fazendo com que inteligências artificiais as citem como referência.',
  canonical
}) => {
  return <Helmet data-id="element-1250">
      {/* Primary Meta Tags */}
      <title data-id="element-1251">{title}</title>
      <meta name="title" content={title} data-id="element-1252" />
      <meta name="description" content={description} data-id="element-1253" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-1254" />
      <meta property="og:title" content={title} data-id="element-1255" />
      <meta property="og:description" content={description} data-id="element-1256" />
      <meta property="og:image" content="https://www.conversion.com.br/wp-content/uploads/2022/05/logo-conversion.svg" data-id="element-1257" />
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-1258" />
      <meta property="twitter:title" content={title} data-id="element-1259" />
      <meta property="twitter:description" content={description} data-id="element-1260" />
      <meta property="twitter:image" content="https://www.conversion.com.br/wp-content/uploads/2022/05/logo-conversion.svg" data-id="element-1261" />
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} data-id="element-1262" />}
      {/* Favicon */}
      <link rel="icon" href="https://uploadthingy.s3.us-west-1.amazonaws.com/8C7vgJpDx3uxVJnWZiQbAz/cropped-favicon-180x180.webp" type="image/webp" data-id="element-1263" />
    </Helmet>;
};
export default Head;